var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_90",
    "data-name": "Group 90",
    transform: "translate(-31 -207)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_406",
    "data-name": "Group 406",
    transform: "translate(562.526 119.583)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3783",
    "data-name": "Path 3783",
    d: "M-510.89,106.415l1.312,1.289-1.639,1.617-1.288-1.29a6.957,6.957,0,0,1-6.161.967,6.8,6.8,0,0,1-3.821-2.982,6.955,6.955,0,0,1,1.3-8.854,7.012,7.012,0,0,1,8.939-.26A7.011,7.011,0,0,1-510.89,106.415Zm-5.713,1.161a5.2,5.2,0,0,0,5.2-5.215,5.192,5.192,0,0,0-5.214-5.195,5.191,5.191,0,0,0-5.192,5.217A5.226,5.226,0,0,0-516.6,107.575Z",
    fill: "#7a7a7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3784",
    "data-name": "Path 3784",
    d: "M-196.341,424.617a1.754,1.754,0,0,1-1.4-.536q-1.791-1.77-3.563-3.558a.772.772,0,0,1,.009-1.149q.954-.965,1.919-1.918a.773.773,0,0,1,1.149-.009c1.178,1.168,2.363,2.33,3.516,3.522a2.135,2.135,0,0,1-.648,3.415A1.684,1.684,0,0,1-196.341,424.617Z",
    transform: "translate(-309.392 -309.209)",
    fill: "#7a7a7a"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/SearchIcon.a95b2cdb5334324b8745fc9bb7f3e4a8.svg";
export { ForwardRef as ReactComponent };